// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActivateDtaWorkflow201Response
 */
export interface ActivateDtaWorkflow201Response {
    /**
     * 
     * @type {string}
     * @memberof ActivateDtaWorkflow201Response
     */
    dta_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivateDtaWorkflow201Response
     */
    workflow_stage?: string;
}

/**
 * Check if a given object implements the ActivateDtaWorkflow201Response interface.
 */
export function instanceOfActivateDtaWorkflow201Response(value: object): value is ActivateDtaWorkflow201Response {
    return true;
}

export function ActivateDtaWorkflow201ResponseFromJSON(json: any): ActivateDtaWorkflow201Response {
    return ActivateDtaWorkflow201ResponseFromJSONTyped(json, false);
}

export function ActivateDtaWorkflow201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateDtaWorkflow201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'] == null ? undefined : json['dta_id'],
        'workflow_stage': json['workflow_stage'] == null ? undefined : json['workflow_stage'],
    };
}

export function ActivateDtaWorkflow201ResponseToJSON(json: any): ActivateDtaWorkflow201Response {
    return ActivateDtaWorkflow201ResponseToJSONTyped(json, false);
}

export function ActivateDtaWorkflow201ResponseToJSONTyped(value?: ActivateDtaWorkflow201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'workflow_stage': value['workflow_stage'],
    };
}
